module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-MedItalic.59723e2.woff2";